import Hls from "hls.js";
import { useEffect } from "react";
import { handleMultiLiveFragLoading, handleMultiLiveHlsConfig, handleMultiLiveMediaAttached } from "../../../../../redux/actions";

const MultiLiveVideoTag = () => {

    useEffect(() => {
        let hls = new Hls(handleMultiLiveHlsConfig());

        // ---- Hls.js ----
        if (Hls.isSupported()) {
            hls.attachMedia(document.getElementById(`multilive-player`) as HTMLMediaElement);
            hls.on(Hls.Events.MEDIA_ATTACHED, () => handleMultiLiveMediaAttached(Hls,hls));
            hls.on(Hls.Events.FRAG_LOADING, () => handleMultiLiveFragLoading(hls))
        }

    }, []);

    return (
        <video
            autoPlay={true}
            id={`multilive-player`}
            className={`!pl-rounded-[4px] pl-h-full pl-w-full`}
            muted
        />
    )
}

export default MultiLiveVideoTag;